import { Hidden } from '@material-ui/core';
import { Header, PagesItem, Sidemenu, TopHeader } from 'components';
import Footer from 'components/Footer/Footer';
import { QueryParams } from 'config';
import { CICLO_FACTURACION } from 'navigation';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { actualizarLogo } from 'store';
import { obtenerLogo } from 'utils';
import Routes from './navigation/RouterConfig';
import useStyles from './RootStyles';

const Root = ({ path }: { path: string }) => {
  /**
   * styles
   */
  const styles = useStyles();
  /**
   * history
   */
  const history = useHistory();
  /**
   * Uso del i18n para traducciones
   */
  const { t } = useTranslation();

  /**
   * Variable que maneja query params
   */
  const query = QueryParams();
  /**
   * valor de empresa obtenido por query params
   */
  const tipoEmpresa = query.get('empresa');

  /**
   * uso del dispatch de redux
   */
  const dispatch = useDispatch();

  /**
   * Metodo que hace llamado de servicio para validar numero de cliente
   */
  const validarLogo = (codDistribuidora: string) => {
    const actualizarLogoBody = {
      urlLogo: obtenerLogo(codDistribuidora),
    };
    dispatch(actualizarLogo(actualizarLogoBody));
  };

  useEffect(() => {
    if (tipoEmpresa) {
      validarLogo(tipoEmpresa);
    } else {
      validarLogo('');
    }
  }, []);

  /**
   * Accion boton que retrocede a paso 1
   */
  const onClickVolver = () => {
    history.push(CICLO_FACTURACION);
  };

  return (
    <section className={styles.root}>
      <TopHeader className={styles.lineaTope} />
      <Hidden only={['md', 'lg', 'xl']}>
        <Sidemenu />
      </Hidden>
      <Header className={styles.header} />
      <section className={styles.content}>
        <section className={styles.tracking}>
          <PagesItem
            titulo={t('tracking:paginas.tracking.titulo')}
            path={path}
            textoVolver={t('tracking:paginas.tracking.textoVolver')}
            onClickVolver={onClickVolver}
            dataTestId="pagina-principal"
          >
            <Routes path={path} />
          </PagesItem>
        </section>
      </section>
      <Footer className={styles.footer} />
    </section>
  );
};

export default Root;
